﻿import { Spinner } from 'react-bootstrap';

interface Props {
  sentinelRef: (node: HTMLElement | null) => void;
  loadingMore: boolean;
  hasMore: boolean;
  total: number;
  loadedCount: number;
}

export default function InfiniteScrollSentinel({ sentinelRef, loadingMore, hasMore, total, loadedCount }: Props) {
  return (
    <div className="text-center py-3">
      {loadingMore && (
        <div className="d-flex justify-content-center align-items-center gap-2">
          <Spinner animation="border" size="sm" className="spinner-primary" />
          <small className="text-muted">Caricamento...</small>
        </div>
      )}
      {hasMore && !loadingMore && <div ref={sentinelRef} style={{ height: 1 }} />}
      {!hasMore && loadedCount > 0 && (
        <small className="text-muted">
          {loadedCount} di {total} risultati
        </small>
      )}
    </div>
  );
}
